var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("activities.title"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "dashboard" },
                  slot: "item-title",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.home")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("activities.title")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-actions row" }, [
          _c(
            "div",
            { staticClass: "col-xs-2" },
            [
              _c(
                "base-button",
                {
                  attrs: {
                    outline: true,
                    icon: _vm.filterIcon,
                    size: "large",
                    color: "theme",
                    "right-icon": "",
                  },
                  on: { click: _vm.toggleFilter },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.filter")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFilters,
                expression: "showFilters",
              },
            ],
            staticClass: "filter-section",
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-3" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.from"))),
                  ]),
                  _vm._v(" "),
                  _c("base-date-picker", {
                    attrs: {
                      "calendar-button": true,
                      "calendar-button-icon": "calendar",
                    },
                    model: {
                      value: _vm.from_date,
                      callback: function ($$v) {
                        _vm.from_date = $$v
                      },
                      expression: "from_date",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.to"))),
                  ]),
                  _vm._v(" "),
                  _c("base-date-picker", {
                    attrs: {
                      "calendar-button": true,
                      "calendar-button-icon": "calendar",
                    },
                    model: {
                      value: _vm.to_date,
                      callback: function ($$v) {
                        _vm.to_date = $$v
                      },
                      expression: "to_date",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.select_account"))),
                  ]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.accountOption,
                      "group-select": false,
                      searchable: true,
                      "show-labels": false,
                      placeholder: _vm.$t("dashboard.select_account"),
                      "group-values": "options",
                      "group-label": "label",
                      "track-by": "id",
                      label: "company_name",
                    },
                    model: {
                      value: _vm.selectedAccount,
                      callback: function ($$v) {
                        _vm.selectedAccount = $$v
                      },
                      expression: "selectedAccount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.select_activity"))),
                  ]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.activityOption,
                      searchable: true,
                      "show-labels": false,
                      placeholder: _vm.$t("general.select_activity"),
                    },
                    model: {
                      value: _vm.selectedActivity,
                      callback: function ($$v) {
                        _vm.selectedActivity = $$v
                      },
                      expression: "selectedActivity",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "clear-filter", on: { click: _vm.clearFilter } },
                [_vm._v(_vm._s(_vm.$t("general.clear_all")))]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 mt-5" }, [
          _c("div", { staticClass: "card dashboard-card" }, [
            _vm.updateChart && _vm.isLoaded
              ? _c("div", { staticClass: "graph-body" }, [
                  _c(
                    "div",
                    { staticClass: "card-body col-md-12 col-lg-12 col-xl-10" },
                    [
                      _vm.updateChart && _vm.isLoaded
                        ? _c("bar-chart", {
                            attrs: {
                              label: _vm.selected_user_type,
                              labels: _vm.chartData.labels,
                              values: _vm.chartData.values,
                              backgroundColor: _vm.chartData.colors,
                              borderColor: _vm.chartData.colors,
                              hoverBackgroundColor: _vm.chartData.colors,
                              hoverBorderColor: _vm.chartData.colors,
                              updateChart: _vm.updateChart,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-desc col-md-12 col-lg-12 col-xl-2" },
                    [
                      _vm.updateChart && _vm.isLoaded
                        ? _c(
                            "div",
                            { staticClass: "stats" },
                            _vm._l(_vm.chartData.info, function (info) {
                              return _c(
                                "div",
                                { key: info.label, staticClass: "description" },
                                [
                                  _c("span", {
                                    staticClass: "title",
                                    domProps: { innerHTML: _vm._s(info.label) },
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "total",
                                      style: { color: info.color },
                                    },
                                    [
                                      info.label == "Total Financed"
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$utils.formatMoney(
                                                  info.count,
                                                  _vm.defaultCurrency
                                                )
                                              ),
                                            },
                                          })
                                        : _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(info.count),
                                            },
                                          }),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body col-md-12 col-lg-12 col-xl-12" },
              [
                _vm.updateLoginHistory && _vm.isLoaded
                  ? _c(
                      "table-component",
                      {
                        attrs: {
                          "show-filter": false,
                          data: _vm.loginData,
                          "table-class": "table",
                        },
                      },
                      [
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("login_info.date"),
                            "sort-as": "created_at",
                            show: "formattedCreatedAt",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("login_info.login_time"),
                            show: "formattedCreatedAtDetail",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("login_info.login_detail"),
                            show: "loginDetail",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }